/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_History_OlderInputs */



/**
* | output |
* | --- |
* | "Older" |
*
* @param {Assistant_History_OlderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_history_older = /** @type {((inputs?: Assistant_History_OlderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_History_OlderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plus vieux")
	if (locale === "de") return /** @type {LocalizedString} */ ("Älter")
	if (locale === "it") return /** @type {LocalizedString} */ ("Più vecchio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Старше")
	if (locale === "es") return /** @type {LocalizedString} */ ("Más viejo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("老年人")
	if (locale === "ja") return /** @type {LocalizedString} */ ("年配の方")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पुराने")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mais velho")
	return /** @type {LocalizedString} */ ("Older")
});